/**
 * Hex color validation utilities for the wizard's Visual Config modal.
 * Isolated as a pure module so tests can import without pulling in the
 * full React component dependency tree.
 */

/** CSS hex color pattern: #RRGGBB (case-insensitive). */
const HEX_COLOR_RE = /^#[0-9a-fA-F]{6}$/;

/**
 * Validate a color field value. Returns an error message when the value
 * is non-empty but not a valid 6-digit hex string; returns null when
 * the value is empty (field is optional) or is valid.
 *
 * Exported as both named and default so eslint's
 * import/prefer-default-export rule is satisfied without forcing a
 * rename ripple through the named-import call sites.
 */
export function validateHexColor(value: string): string | null {
  if (!value) return null;
  return HEX_COLOR_RE.test(value) ? null : "Must be #RRGGBB (e.g. #FF0000)";
}

export default validateHexColor;
